module.exports = __webpack_public_path__ + "static/img/Ocean.589c6c67.png";